import { render } from "./DataActions.vue?vue&type=template&id=76144049&scoped=true"
import script from "./DataActions.vue?vue&type=script&lang=js"
export * from "./DataActions.vue?vue&type=script&lang=js"

import "./DataActions.vue?vue&type=style&index=0&id=76144049&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76144049"]])

export default __exports__